<script>

export default {
    beforeMount(){
        this.redirect();
    },
    methods: {
        redirect: function(e){
            let uri = window.location.href.split('?');
            let vars = uri[1].split('&');
            let code = 10
            let message = '결제승인에 실패했습니다.';

            for (var key in vars) { 
                var kv = vars[key];
                var kvArr = kv.split('=');
                var k = kvArr[0];
                var v = kvArr[1];
                if(k == 'code'){
                    code = v;
                } else if(k == 'message'){
                    message = decodeURI(v);
                } 
            }
            
            swal(message, {
                icon: "info",
            }).then(() => {
                this.$router.push('/main/insta?tab=apply&scroll=0');
            });                      
        }
    

    }
}
</script>



// WEBPACK FOOTER //
// src/components/pay/InstaFail.vue